import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "mt-20 list-box"
  }, [!_vm.isPending && _vm.problemList.length ? _c('ul', {
    staticClass: "gd-scrollbar"
  }, _vm._l(_vm.problemList, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "list-box-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'FaqDetailPage',
          query: {
            id: item.id,
            channel: item.channel
          },
          params: _vm.routeParams
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1);
  }), 0) : _vm._e(), _vm.isPending ? _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  }) : _vm._e(), !_vm.isPending && !_vm.problemList.length ? _c('a-empty', {
    staticClass: "mt-50",
    attrs: {
      "description": _vm.tc('暂无数据')
    }
  }) : _vm._e(), !_vm.isPending && _vm.problemList.length && _vm.total > _vm.pageSize ? _c('my-pagination', {
    attrs: {
      "total": _vm.total,
      "value": _vm.page,
      "page-size": _vm.pageSize
    },
    on: {
      "onChange": _vm.handlePageChange,
      "update:pageSize": function ($event) {
        _vm.pageSize = $event;
      },
      "update:page-size": function ($event) {
        _vm.pageSize = $event;
      }
    }
  }) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };